<template>
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      transform="translate(0 0.596191)"
      fill="white"
    />
    <rect
      x="12"
      y="15.5962"
      width="31"
      height="24"
      rx="2"
      fill="white"
      stroke="#4D4E58"
      stroke-width="1.6"
    />
    <rect
      x="4"
      y="10.5962"
      width="31"
      height="24"
      rx="2"
      fill="white"
      stroke="#4D4E58"
      stroke-width="1.6"
    />
    <path
      d="M12.4923 13.5962H8C7.44771 13.5962 7 14.0439 7 14.5962V30.5962C7 31.1485 7.44772 31.5962 8 31.5962H28L12.4923 13.5962Z"
      fill="#E0E5FF"
    />
    <path
      d="M4 22.5962L9.5 19.5962L16.5 27.0962L23.5 16.0962L30.5 22.0962"
      stroke="#4D4E58"
    />
    <rect
      x="8"
      y="18.0962"
      width="3"
      height="3"
      rx="1.5"
      fill="#7B90FF"
      stroke="#4D4E58"
    />
    <rect
      x="15"
      y="25.5962"
      width="3"
      height="3"
      rx="1.5"
      fill="#7B90FF"
      stroke="#4D4E58"
    />
    <rect
      x="22"
      y="14.5962"
      width="3"
      height="3"
      rx="1.5"
      fill="#7B90FF"
      stroke="#4D4E58"
    />
    <rect
      x="29"
      y="20.5962"
      width="3"
      height="3"
      rx="1.5"
      fill="#7B90FF"
      stroke="#4D4E58"
    />
  </svg>
</template>
